<form [formGroup]="deliveryForm">
  <!-- Fila 1: Urgencia + Fecha (col-6 fijo) -->
  <div class="row d-flex">
    <div class="col-6 mb-3">
      <label for="delivery_urgency" class="form-label">{{
        "inputs.delivery_urgency.delivery_urgency" | translate
      }}</label>
      <ng-select formControlName="delivery_urgency" [items]="delivery_urgency_"
        [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate">
        <ng-template ng-label-tmp let-item="item">
          {{ "inputs.delivery_urgency." + item | translate }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ "inputs.delivery_urgency." + item | translate }}
        </ng-template>
      </ng-select>
    </div>
    <div class="col-6 mb-3">
      <label for="delivery_client_expected_date" class="form-label"
        >{{ "inputs.delivery_client_expected_date" | translate }}
      </label>
      <span class="info-icon" tabindex="0">
        <i class="icon-notification"></i>
        <span class="tooltip">{{
          "inputs.i.delivery_client_expected_date" | translate
        }}</span>
      </span>
      <div class="input-group">
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="delivery_client_expected_date"
            formControlName="delivery_client_expected_date"
            placeholder="{{
              'inputs.delivery_client_expected_date' | translate
            }}"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="delivery_client_expected_date"
          ></mat-datepicker-toggle>
          <mat-datepicker #delivery_client_expected_date></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="row d-flex align-items-end">
    <!-- Fila 2: Contacto + Teléfono (col-6 fijo) -->
    <div class="col-6 mb-3">
      <label for="delivery_contact" class="form-label">{{
        "inputs.delivery_contact" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="delivery_contact"
          required
          formControlName="delivery_contact"
          placeholder="{{ 'inputs.delivery_contact' | translate }}"
          #inputFieldDeliveryContact
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="
              copyToClipboard(inputFieldDeliveryContact.value, $event)
            "
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="col-6 mb-3">
      <label for="delivery_phone" class="form-label">{{
        "inputs.delivery_phone" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="delivery_phone"
          required
          formControlName="delivery_phone"
          placeholder="{{ 'inputs.delivery_phone' | translate }}"
          #inputFieldDeliveryPhone
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="copyToClipboard(inputFieldDeliveryPhone.value, $event)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row linea"></div>

  <div class="row d-flex align-items-end">
    <div class="col-8 mb-3">
      <div class="d-flex justify-content-between">
        <label for="delivery_address" class="form-label">{{
          "inputs.delivery_address" | translate
        }}</label>
      </div>

      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="delivery_address"
          required
          formControlName="delivery_address"
          placeholder="{{ 'inputs.delivery_address' | translate }}"
          #inputFieldDeliveryAddress
          (blur)="onAddressBlur()"
          (input)="onAddressInput()"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="
              copyToClipboard(inputFieldDeliveryAddress.value, $event)
            "
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="col-4 mb-3">
      <label for="delivery_state" class="form-label">{{
        "inputs.delivery_state" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="delivery_state"
          formControlName="delivery_state"
          placeholder="{{ 'inputs.delivery_state' | translate }}"
          #inputFieldDeliveryState
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="copyToClipboard(inputFieldDeliveryState.value, $event)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row d-flex align-items-end">
    <!-- Fila 4: CP + Ciudad (col-6 fijo) -->
    <div class="col-6 mb-3">
      <label for="delivery_postal_code" class="form-label">{{
        "inputs.delivery_postal_code" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="delivery_postal_code"
          required
          formControlName="delivery_postal_code"
          placeholder="{{ 'inputs.delivery_postal_code' | translate }}"
          #inputFieldDeliveryCP
          (blur)="onAddressBlur()"
          (input)="onAddressInput()"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="copyToClipboard(inputFieldDeliveryCP.value, $event)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="col-6 mb-3">
      <label for="delivery_city" class="form-label">{{
        "inputs.delivery_city" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="delivery_city"
          required
          formControlName="delivery_city"
          placeholder="{{ 'inputs.delivery_city' | translate }}"
          #inputFieldDeliveryCity
          (blur)="onAddressBlur()"
          (input)="onAddressInput()"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="copyToClipboard(inputFieldDeliveryCity.value, $event)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Ubicación de entrega — solo suppliers, colapsable -->
  <div *ngIf="isSupplier" class="map-collapsible">
    <div class="map-collapsible-header" (click)="toggleMapSection()">
      <span class="map-collapsible-label">
        <span class="form-label mb-0">{{ 'inputs.delivery_map' | translate }}</span>
        <i *ngIf="deliveryForm.get('delivery_latitude')?.value && deliveryForm.get('delivery_longitude')?.value"
           class="icon-check ms-1" style="color: #28a745; font-size: 0.85rem;"></i>
      </span>
      <i class="icon-chevron-down map-chevron" [class.open]="mapSectionOpen"></i>
    </div>
    <div class="map-collapsible-body" *ngIf="mapSectionOpen">
      <div class="row" *ngIf="mapEditable">
        <div class="col-12 mb-3">
          <google-map *ngIf="mapReady"
            width="100%"
            height="300px"
            [center]="mapCenter"
            [zoom]="mapZoom"
            [options]="mapOptions"
            (mapClick)="onMapClick($event)">
            <map-marker *ngIf="markerPosition" [position]="markerPosition"></map-marker>
          </google-map>
        </div>
      </div>
      <div class="row d-flex align-items-end">
        <div class="col-6 mb-3">
          <label for="delivery_latitude" class="form-label">{{ 'inputs.delivery_latitude' | translate }}</label>
          <input type="text" class="form-control" id="delivery_latitude"
            formControlName="delivery_latitude"
            placeholder="{{ 'inputs.delivery_latitude' | translate }}"
            (blur)="onCoordsBlur()" />
        </div>
        <div class="col-6 mb-3">
          <label for="delivery_longitude" class="form-label">{{ 'inputs.delivery_longitude' | translate }}</label>
          <input type="text" class="form-control" id="delivery_longitude"
            formControlName="delivery_longitude"
            placeholder="{{ 'inputs.delivery_longitude' | translate }}"
            (blur)="onCoordsBlur()" />
        </div>
      </div>
    </div>
  </div>

  <div class="row linea"></div>

  <!-- Lugar entrega col-12 mobile, dealer+fecha col-6 mobile. Desktop: 3x col-4 -->
  <div class="row d-flex align-items-end">
    <div class="col-12 col-xl-4 mb-3">
      <label for="delivery_place" class="form-label">{{
        "inputs.delivery_place" | translate
      }}</label>
      <ng-select formControlName="delivery_place" [items]="delivery_place" bindValue="key" bindLabel="name"
        [placeholder]="'inputs.delivery_place' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate">
      </ng-select>
    </div>

    <div class="col-6 col-xl-4 mb-3">
      <label for="delivery_dealer" class="form-label">{{
        "inputs.delivery_dealer" | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="delivery_dealer"
          required
          formControlName="delivery_dealer"
          placeholder="{{ 'inputs.delivery_dealer' | translate }}"
        />
      </div>
    </div>
    <div class="col-6 col-xl-4 mb-3">
      <label for="delivery_appointment_date" class="form-label">{{
        "inputs.delivery_appointment_date" | translate
      }}</label>
      <span class="info-icon" tabindex="0">
        <i class="icon-notification"></i>
        <span class="tooltip">{{
          "inputs.i.delivery_appointment_date" | translate
        }}</span>
      </span>
      <div class="input-group">
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="delivery_appointment_date"
            formControlName="delivery_appointment_date"
            placeholder="{{ 'inputs.delivery_appointment_date' | translate }}"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="delivery_appointment_date"
          ></mat-datepicker-toggle>
          <mat-datepicker #delivery_appointment_date></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Ref transportista + Transportista (col-6 mobile, col-4 desktop) -->
  <div class="row d-flex align-items-end">
    <div class="col-6 col-xl-4 mb-3">
      <label for="logistic_reference" class="form-label">{{
        "inputs.logistic_reference" | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="logistic_reference"
          required
          formControlName="logistic_reference"
          placeholder="{{ 'inputs.logistic_reference' | translate }}"
        />
      </div>
    </div>

    <div class="col-6 col-xl-4 mb-3">
      <label for="logistic_id" class="form-label">{{
        "inputs.logistic_id" | translate
        }}</label>
      <ng-select formControlName="logistic_id" [items]="logisticData" bindValue="reference" bindLabel="name"
        [placeholder]="'inputs.logistic_id' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate">
      </ng-select>
    </div>
  </div>

  <div class="row">
    <div class="mb-3">
      <label for="logistic_comments" class="form-label">{{
        "inputs.logistic_comments" | translate
      }}</label>
      <div class="input-group">
        <textarea
          class="form-control textarea100"
          id="logistic_comments"
          rows="2"
          formControlName="logistic_comments"
        ></textarea>
      </div>
    </div>
  </div>
  <!-- 3 fechas: col-12 mobile, col-4 desktop -->
  <div class="row d-flex align-items-end">
    <div class="col-12 col-xl-4 mb-3">
      <label for="delivery_first_expected_date" class="form-label"
        >{{ "inputs.delivery_first_expected_date" | translate
        }}<span class="required">*</span></label
      >

      <span class="info-icon" tabindex="0">
        <i class="icon-notification"></i>
        <span class="tooltip">{{
          "inputs.i.delivery_first_expected_date" | translate
        }}</span>
      </span>

      <div class="input-group">
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="delivery_first_expected_date"
            formControlName="delivery_first_expected_date"
            placeholder="{{
              'inputs.delivery_first_expected_date' | translate
            }}"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="delivery_first_expected_date"
          ></mat-datepicker-toggle>
          <mat-datepicker #delivery_first_expected_date></mat-datepicker>
        </mat-form-field>
      </div>
      <!--  <input type="text" class="form-control" id="delivery_first_expected_date" required
        formControlName="delivery_first_expected_date" placeholder="{{
          'inputs.delivery_first_expected_date'
            | translate
        }}" /> -->
    </div>
    <div class="col-12 col-xl-4 mb-3">
      <label for="delivery_expected_date" class="form-label"
        >{{ "inputs.delivery_expected_date" | translate
        }}<span class="required">*</span></label
      >
      <span class="info-icon" tabindex="0">
        <i class="icon-notification"></i>
        <span class="tooltip">{{
          "inputs.i.delivery_expected_date" | translate
        }}</span>
      </span>
      <div class="input-group">
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="delivery_expected_date"
            formControlName="delivery_expected_date"
            placeholder="{{ 'inputs.delivery_expected_date' | translate }}"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="delivery_expected_date"
          ></mat-datepicker-toggle>
          <mat-datepicker #delivery_expected_date></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="col-12 col-xl-4 mb-3">
      <label for="delivery_date" class="form-label"
        >{{ "inputs.delivery_date" | translate }}
      </label>
      <span class="info-icon" tabindex="0">
        <i class="icon-notification"></i>
        <span class="tooltip">{{
          "inputs.i.delivery_date" | translate
        }}</span>
      </span>
      <div class="input-group">
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="delivery_date"
            formControlName="delivery_date"
            placeholder="{{ 'inputs.delivery_date' | translate }}"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="delivery_date"
          ></mat-datepicker-toggle>
          <mat-datepicker #delivery_date></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="row linea"></div>

  <div class="row">
    <div class="mb-3">
      <label for="delivery_delay_notes" class="form-label">{{
        "inputs.delivery_delay_notes" | translate
      }}</label>
      <div class="input-group">
        <textarea
          class="form-control textarea100"
          id="delivery_delay_notes"
          rows="2"
          required
          formControlName="delivery_delay_notes"
        ></textarea>
      </div>
    </div>
  </div>
</form>
